import { render } from "./EmailPage.vue?vue&type=template&id=e4949e40"
import script from "./EmailPage.vue?vue&type=script&lang=js"
export * from "./EmailPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__